import style from './ModalSelectSample.module.css';

import classNames from 'classnames';
import { address_server_short, PUBLIC_ASSETS, COLORS } from 'config';
import { Progress } from 'rsuite';
import FileSaver from 'file-saver';
import { getFileSample } from 'services/sample.services';
import SwitchWidget from 'components/Widgets/Switch';

const UserFields = ({ val, unitsList }) => {
  const parseValue = (val) => {
    try {
      return JSON.parse(val);
    } catch {
      return val;
    }
  };

  const loadFile = (file) => {
    const fileExtension = file.split('/').pop();
    const loadFileBD = async () => {
      const res = await getFileSample(file);
      const data = new Blob([res]);
      FileSaver.saveAs(data, fileExtension);
    };
    loadFileBD();
  };

  if (val.type.type_name == 'finance')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>
          {parseValue(val.value).value
            ? parseValue(val.value).value + ' ' + parseValue(val.value).setting.postfix
            : ''}
        </div>
      </div>
    );

  if (val.type.type_name == 'color')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div
          className={style.colorBlock}
          style={{ backgroundColor: `${parseValue(val.value).value}` }}
        ></div>
      </div>
    );

  if (val.type.type_name == 'select_check')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        {parseValue(val.value).setting?.items !== '' ? (
          <div className={style.userTextW}>
            {parseValue(val.value).setting?.items?.replace(',', ', ')}
          </div>
        ) : (
          ''
        )}
      </div>
    );

  if (val.type.type_name == 'switch')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <SwitchWidget disabled={true} selected={parseValue(val.value).value} onChange={() => {}} />
      </div>
    );

  if (val.type.type_name == 'float' || val.type.type_name == 'integer')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>
          {(parseValue(val.value).value == undefined ? '' : parseValue(val.value).value) +
            ' ' +
            (unitsList?.find((value) => value.id == parseValue(val.setting)?.unit)?.name ==
            undefined
              ? ''
              : unitsList?.find((value) => value.id == parseValue(val.setting)?.unit)?.name)}
        </div>
      </div>
    );

  if (val.type.type_name == 'icon')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div>
          <img
            className={style.iconContainer}
            src={address_server_short + PUBLIC_ASSETS + parseValue(val.value)?.setting?.file}
          />
        </div>
      </div>
    );

  if (val.type.type_name == 'image')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div>
          {parseValue(val.value) &&
            parseValue(val.value)?.map((item, index) => {
              return (
                <a
                  key={index}
                  target={'_blank'}
                  href={address_server_short + '' + item}
                  rel="noreferrer"
                >
                  {item?.split('/')?.[2]},
                </a>
              );
            })}
        </div>
      </div>
    );

  if (val.type.type_name == 'yes_no')
    return (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>{parseValue(val.value).value == 'yes' ? 'Да' : 'Нет'}</div>
      </div>
    );

  if (val.type.type_name == 'progress')
    return parseValue(val.value).setting?.value !== '' ? (
      <div className={classNames(style.info3, style.colorBlockCont)}>
        <div className={style.nameField}>{val.name}:</div>
        <Progress
          percent={parseFloat(parseValue(val.value).value ?? 0)}
          strokeColor={
            parseValue(val.setting)?.find((val) => val.param == 'color')?.color ??
            COLORS.color_brand
          }
          strokeWidth={22}
          showInfo={
            parseValue(val.setting)?.find((val) => val.param == 'percentVisible')?.value || false
          }
        />
      </div>
    ) : (
      ''
    );

  if (val.value && val.type.type_name == 'file')
    return (
      <div className={style.info3 + ' ' + style.info_textCont}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>
          {parseValue(val.value) &&
            parseValue(val.value)?.map((item, index) => {
              if (index !== JSON.parse(JSON.stringify(val.value)).length - 1)
                return (
                  <div
                    key={index}
                    className={style.fileContainer}
                    onClick={() => loadFile(item)}
                  >{` ${item?.split('/')?.pop()}, `}</div>
                );
              else
                return (
                  <div
                    key={index}
                    className={style.fileContainer}
                    onClick={() => loadFile(item)}
                  >{` ${item?.split('/')?.pop()}`}</div>
                );
            })}
        </div>
      </div>
    );

  if (val.value && val.type.type_name == 'barcode')
    return (
      <div className={style.info3 + ' ' + style.info_textCont}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>
          {parseValue(val.value).setting?.barcode} {parseValue(val.value).setting?.value}
        </div>
      </div>
    );

  if (val.value || val.value == '')
    return (
      <div className={style.info3 + ' ' + style.info_textCont}>
        <div className={style.nameField}>{val.name}:</div>
        <div className={style.userTextW}>{parseValue(val.value).value}</div>
      </div>
    );

  return null;
};

export default UserFields;
